import { lazy } from "react";

import CareIcon from "@/CAREUI/icons/CareIcon";

import { PluginManifest } from "@/pluginTypes";

const OnboardingPage = lazy(() => import("./OnboardingPage"));

// Wording: public/locale/<lang>.json, loaded by CARE as this plugin's i18n
// namespace (served at /local-plugins/myhis-onboarding/locale/).
// Every screen talks to the myhis_onboarding plug only. While its
// ONBOARDING_ENABLED flag is off (it is on by default) the page says so.
const manifest: PluginManifest = {
  plugin: "myhis-onboarding",
  routes: {
    // The facility's setup desk: the wizard, the patient import and the
    // print settings (managers).
    "/facility/:facilityId/setup": ({ facilityId }) => (
      <OnboardingPage facilityId={facilityId} />
    ),
  },
  components: {
    FacilityHomeActions: lazy(() => import("./SetupButton")),
    // A typed pincode fills the patient's district (the plug's pincode
    // table, LGD + India Post data); ambiguous pincodes offer a choice.
    PatientRegistrationForm: lazy(() => import("./PincodeGeoFill")),
  },
  // Setup in the facility's left navigation (url prefixed with
  // /facility/<id>/ by CARE; a static label, read before the locale loads).
  navItems: [
    {
      name: "Setup",
      url: "setup",
      icon: <CareIcon icon="l-setting" />,
    },
  ],
};

export default manifest;
